import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type ReadUserGroupsV3 = OpalApi<'ReadUserGroupsV3', 200>

export const readUserGroups: ReadUserGroupsV3 = async ({
  params,
}: Parameters<ReadUserGroupsV3>[0] = {}) => {
  const url = new URL('/user_groups/v3/user_groups', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<OpalApiResponseDocument<'ReadUserGroupsV3', 200>>(url.toString())
    .then((res) => res.data)
}
